import { render, staticRenderFns } from "./ModalGroup.vue?vue&type=template&id=5d60cedf&scoped=true&"
import script from "./ModalGroup.vue?vue&type=script&lang=js&"
export * from "./ModalGroup.vue?vue&type=script&lang=js&"
import style0 from "./ModalGroup.vue?vue&type=style&index=0&id=5d60cedf&prod&lang=scss&scoped=true&"
import style1 from "./ModalGroup.vue?vue&type=style&index=1&id=5d60cedf&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d60cedf",
  null
  
)

export default component.exports